export default __webpack_public_path__ + "static/media/MissingNo.b0ff373b.png";